import { AfterContentInit, Component, ContentChild, Input, OnChanges, TemplateRef } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-expandable-list',
  templateUrl: './expandable-list.component.html',
  styleUrls: ['./expandable-list.component.scss']
})
export class ExpandableListComponent implements AfterContentInit, OnChanges {
  @ContentChild(TemplateRef) child!: TemplateRef<any>;
  /**
   * n < 0 - hide nothing
   * n = 0 - hide all
   * n > 0 - hide all, but n
   */
  @Input() sliceLength: number = -1;
  @Input() allData: any[] = [];

  /** Show button text, vars $all $sliced $hidden */
  @Input() showText = `${this.ls.translate('button.showAll')} ($all)`;
  /** Hide button text, vars $all $sliced $hidden */
  @Input() hideText = `${this.ls.translate('button.hide')} ($hidden)`;

  @Input() buttonClass = '';
  @Input() buttonStyle?: string;

  public shownData: any[] = [];
  public areShownAll: boolean = false;

  constructor(private ls: LocalizationService) {}

  ngAfterContentInit(): void {
    if (this.sliceLength >= 0) {
      this.hideAll();
    } else {
      this.showAll();
    }
  }

  ngOnChanges(): void {
    // update show data
    if (this.areShownAll) {
      this.showAll();
    } else {
      this.hideAll();
    }
  }

  public showAll() {
    this.shownData = this.allData;
    this.areShownAll = true;
  }

  public hideAll() {
    this.shownData = this.allData.slice(0, Math.min(this.allData.length, this.sliceLength));
    this.areShownAll = false;
  }

  public interpolate(text: string): string {
    return text
      .replace(/\$all/g, this.allData.length.toFixed())
      .replace(/\$sliced/g, this.sliceLength.toFixed())
      .replace(/\$hidden/g, (this.shownData.length - this.sliceLength).toFixed());
  }
}
